import { render, staticRenderFns } from "./ColleagueSelect.vue?vue&type=template&id=2636e030&"
import script from "./ColleagueSelect.vue?vue&type=script&lang=js&"
export * from "./ColleagueSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports